/***************************************************************
Hawaiian Macadamia Nut Services
4/1/20
Alexander Self
Profile Tabs
***************************************************************/
import React from 'react';
import user from '../../../img/user.jpg';
import Card from '../../card';
import { findEmployeeByName } from '../../../utils';
const $ = window.$;

let List = ({ stats, prop1, prop2, header, color, borderColor, headerColor }) => {
  const cardHeader = {
    color: `${color}`,
    textAlign: "center",
    fontSize: "14px",
    fontWeight: 600,
    borderBottom: `1px solid ${borderColor}`,
    backgroundColor: `${headerColor}`,
    padding: "5px 10px"
  };
  return (
    <div className="row">
      <ul className="collection with-header">
        <li style={cardHeader} className="collection-header">{ header }</li>
        {
          stats.map((s) => (
            <li className="collection-item" key={Math.random()}>
              <b>{ s[prop1] }</b> <span className="right-align">{ s[prop2] } hours</span>
            </li>
          ))
        }
      </ul>
    </div>
  )
}

const ProfileTabs = ({ employee, employees, fetchEmployeeProfileByName, stats }) => {
  $(document).ready(function(){
    $('.tabs').tabs();
    $('#stats-bio-collapsible').collapsible();
  });
  return (
    <div className="row">
      <div className="col s12">
        <ul className="tabs light-blue z-depth-1">
          <li className="tab col s4"><a className="white-text" href="#statsBio">Stats Bio</a></li>
          <li className="tab col s4"><a className="white-text" href="#trainingAndSkills">Training and Skills</a></li>
          <li className="tab col s4"><a className="white-text" href="#managedEmployees">Managed Employees</a></li>
        </ul>
      </div>

      <div id="statsBio" className="col s12">
      <ul id={'stats-bio-collapsible'} className="collapsible">
        <li>
          <div className="collapsible-header"><i style={{ color: 'green' }} className="material-icons">eco</i><b style={{ color: 'green' }}>Harvest</b></div>
          <div className="collapsible-body">
            <List stats={stats.harvest.harvestHours} prop1={'field'} prop2={'totalHours'}
              header={'Harvest Hours Per Field'} color={'green'} borderColor={'green'} headerColor={'#e8f5e9'} />
          </div>
        </li>
        <li>
          <div className="collapsible-header">
            <i style={{ color: 'blue' }} className="material-icons">local_shipping</i>
            <b style={{ color: 'blue' }}>Equipment</b>
          </div>
          <div className="collapsible-body">
            <List stats={stats.equipment.equipmentHours} prop1={'equipmentNo'} prop2={'totalHours'}
              header={'Equipment Hours Per Machine'} color={'blue'} borderColor={'blue'} headerColor={'#e1f5fe'} />
          </div>
        </li>
        <li>
          <div className="collapsible-header">
            <i style={{ color: 'red' }} className="material-icons">insert_chart</i>
            <b style={{ color: 'red' }}>Cost Centers</b>
          </div>
          <div className="collapsible-body">
            <List stats={stats.costCenter.costCenterHours} prop1={'costCenterCode'} prop2={'totalHours'}
              header={'Cost Center Hours'} color={'red'} borderColor={'red'} headerColor={'#ffebee'} />
          </div>
        </li>
      </ul>

      </div>
      <div id="trainingAndSkills" className="col s12">
        <div className="row">
          <div className="col s12 m12 l12 xl12">
            <div className="pt-1 user-list">
              { employee.monchiero ?
                <Card header={'Monchiero'} icon={'eco'} desc={'Qualified'} color={'green'} borderColor={'green'} headerColor={'#e8f5e9'}
                  id={'monchiero-profile'} width={"250px"} />
                : ''
              }
              { employee.cdl ?
                <Card header={"Commercial Driver's License (CDL)"} icon={'local_shipping'} desc={'Qualified'} color={'blue'} borderColor={'blue'}
                  headerColor={'#e1f5fe'} id={'cdl-profile'} width={"250px"} />
                : ''
              }
              { employee.equipMastery ?
                <Card header={"Equipment Mastery"} icon={'transform'} desc={'Qualified'} color={'amber'} borderColor={'amber'}
                  headerColor={'#fff8e1'} id={'cdl-equipMastery'} width={"250px"} />
                : ''
              }
              { employee.equipSpecial > 0 ?
                <Card header={"Equipment Specialization"} icon={'memory'} desc={`Qualified: ${employee.equipSpecial} types`} color={'red'} borderColor={'red'}
                  headerColor={'#ffebee'} id={'cdl-equipSpecial'} width={"250px"} />
                : ''
              }
            </div>
          </div>
        </div>
      </div>
      <div id="managedEmployees" className="col s12">
        {
          employee.managedEmployees.length > 0 ?
            <ul className="collection z-depth-1 hoverable managed-list">
              { employee.managedEmployees.filter((e) => e.employeeStatus === 'Active').map((e) => (
                  <li key={e.eid} className="collection-item avatar pointer" onClick={() => fetchEmployeeProfileByName(findEmployeeByName(`${e.firstName} ${e.lastName}`, employees))}>
                    <img src={user} className="circle" alt={''} />
                      <span className="title">{ e.firstName } { e.lastName }</span>
                      <p className="grey-text text-darken-2">
                       { e.positionTitle } <br />
                       { e.department }
                      </p>
                  </li>
                ))
              }
            </ul>
          : 'No Managed Employees'
        }
      </div>
    </div>
  )
}


export default ProfileTabs;


/* END */



// WEBPACK FOOTER //
// ./src/components/profiles/view/profile_tabs.js